import type { MetricRecordData } from "@/types/metrics/contracts"

interface ExpectedBehaviorCompositeMetricCandidate {
  metric_manager?: string | null
  metric_metadata?: MetricRecordData["metric_metadata"] | null
}

export function isExpectedBehaviorCompositeMetric(
  metric: ExpectedBehaviorCompositeMetricCandidate,
): boolean {
  return (
    metric.metric_manager === "manager_composite_evaluation" &&
    (metric.metric_metadata?.criteria_source ?? "test_case") === "test_case" &&
    (metric.metric_metadata?.criteria_path ?? "expected_behaviors") ===
      "expected_behaviors"
  )
}
